import Vue, { PropType } from "vue";
import logger from "@/services/loggerService";

export interface WizardMixin extends Vue {
  onBack: () => void;
  onNext: () => void;
  handleError: (e: Error) => void;
  first: boolean;
  last: boolean;
  loading: boolean;
}

export default Vue.extend({
  data() {
    return {
      loading: false,
    };
  },
  props: {
    steps: {
      type: Array as PropType<string[]>,
      required: false,
      default: [],
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    first(): boolean {
      return this.index == 0;
    },
    last(): boolean {
      return this.index == this.steps.length - 1;
    },
  },
  methods: {
    onBack(): void {
      this.$emit("onPrev");
    },
    onNext() {
      this.$emit("onNext");
    },
    handleError(e: Error): void {
      logger.error(e);
      this.$store.commit(
        "notifications/displayNotification",
        {
          message: e,
          type: "error",
        },
        { root: true }
      );
    },
  },
  watch: {},
});
